import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { ArrowLeft, LogOut } from "lucide-react";

/** Lightweight read-only profile screen reachable from the Pending lock.
 *  Lives outside the AppLayout so it works for both pending and active
 *  users. */
export default function Profile() {
    const { user, logout } = useAuth();

    return (
        <div className="min-h-screen bg-[#050505] text-white p-6 sm:p-10" data-testid="profile-page">
            <div className="max-w-xl mx-auto">
                <Link to="/dashboard" className="text-xs font-mono uppercase tracking-wider text-zinc-400 hover:text-white inline-flex items-center gap-1 mb-8">
                    <ArrowLeft className="w-3 h-3" /> Back
                </Link>
                <div className="label-micro mb-2">Your Profile</div>
                <h1 className="font-display text-3xl mb-6">{user?.name || "—"}</h1>
                <div className="card-base divide-y divide-zinc-900">
                    <Row label="Email" value={user?.email} />
                    <Row label="Role"  value={user?.role} />
                    <Row label="Admin" value={user?.is_admin ? "Yes" : "No"} />
                    <Row label="Status" value={user?.status || "active"} />
                </div>
                <div className="mt-6">
                    <button
                        onClick={logout}
                        data-testid="profile-logout"
                        className="btn-secondary text-sm"
                    >
                        <LogOut className="w-4 h-4" /> Log out
                    </button>
                </div>
            </div>
        </div>
    );
}

function Row({ label, value }) {
    return (
        <div className="flex items-center justify-between gap-3 px-4 py-3">
            <div className="label-micro">{label}</div>
            <div className="text-sm text-white truncate">{String(value || "—")}</div>
        </div>
    );
}
